import { render } from "./TimerBar.vue?vue&type=template&id=37cbe4e8&scoped=true"
import script from "./TimerBar.vue?vue&type=script&lang=js"
export * from "./TimerBar.vue?vue&type=script&lang=js"

import "./TimerBar.vue?vue&type=style&index=0&id=37cbe4e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37cbe4e8"

export default script